import { Box, Button, Grid, ImageList, ImageListItem, Typography } from '@mui/material';
import { useMedicalHealthInformationContext } from '../Context';
import DialogViewer from './DialogViewer';
import { useState } from 'react';
import { MediaImage } from '../types/MedicalHealthInformation';
import { LongLoading } from '@/components/Elements/Loading/LongLoading';
import ErrorDialog from '@/features/misc/ErrorDialog';

const MedicalHealthInformationBranchMediaImage = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [allUnmaskMediaImageList, setAllUnmaskMediaImageList] = useState<MediaImage[]>([]);

  const {
    activeMedicalHealthInformation,
    setDetailMediaImage,
    detailMediaImage,
    fetchMedicalHealthInformationDetail1ForMediaImage,
    fetchMedicalHealthInformationDetail1ForMediaImageAll
  } = useMedicalHealthInformationContext();

  const handleCardClick = (data: MediaImage) => {
    setDetailMediaImage(data);
    setIsOpenModal(true);
  };

  // 鮮明にする(マスク解除)
  const handleUnmask = async () => {
    try {
      await fetchMedicalHealthInformationDetail1ForMediaImage(
        `DocumentReference/${detailMediaImage.id}`,
        activeMedicalHealthInformation.facility_id.toString()
      );
    } catch (e) {
      if (e instanceof Error) {
        setErrorDialogMessage(e.message);
      }
      return Promise.reject(e);
    }
  };

  // 全画像のマスク解除
  const handleClickAllUnmaskButton = async () => {
    setIsLoading(true);

    try {
      const promises: ReturnType<typeof fetchMedicalHealthInformationDetail1ForMediaImageAll>[] = [];
      // APIは1枚ずつしかマスク解除できないので並列化
      activeMedicalHealthInformation.media_image_list.forEach((item) => {
        promises.push(
          fetchMedicalHealthInformationDetail1ForMediaImageAll(
            `DocumentReference/${item.id}`,
            activeMedicalHealthInformation.facility_id.toString()
          )
        );
      });
      const res = await Promise.all(promises);
      setAllUnmaskMediaImageList(res.filter((x): x is MediaImage => x !== undefined));
    } catch (e) {
      if (e instanceof Error) {
        setErrorDialogMessage(e.message);
      }
      return Promise.reject(e);
    } finally {
      setIsLoading(false);
    }
  };

  // マスク解除済みであれば優先して描画
  const imageList = !!allUnmaskMediaImageList.length
    ? allUnmaskMediaImageList
    : activeMedicalHealthInformation.media_image_list;
  // 最初から一つでもis_maskedがあるか、もしくはマスク解除済みであればtrue
  const hideAllubmaskButton =
    activeMedicalHealthInformation.media_image_list.some((item) => item.is_masked) || !!allUnmaskMediaImageList.length;

  return (
    <Box sx={{ marginTop: '12px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container rowSpacing={2}>
            <Grid item>
              <Typography className="text-primary font-semibold  ml-5">ファイル</Typography>
              <ImageList cols={3} gap={4} sx={{ mt: 1 }}>
                {imageList.map((item) => (
                  <ImageListItem key={item.id} onClick={() => handleCardClick(item)} className="cursor-pointer">
                    <img src={item.url} alt={item.url} loading="lazy" style={{ aspectRatio: '1 / 1' }} />
                  </ImageListItem>
                ))}
              </ImageList>
              {!!detailMediaImage.id && (
                <DialogViewer
                  type={'image'}
                  url={detailMediaImage.url}
                  isOpenModal={isOpenModal}
                  onClose={() => setIsOpenModal(false)}
                  onClickButton={handleUnmask}
                  isAlreadyUnmasked={!detailMediaImage.is_masked}
                />
              )}
            </Grid>
          </Grid>
          {!hideAllubmaskButton && (
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              rowSpacing={2}
              style={{
                position: 'fixed',
                bottom: '40px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 'auto'
              }}
            >
              <Grid item className="mx-4">
                <Button
                  style={{ width: '353px' }}
                  className="text-white bg-primary py-2 font-semibold"
                  onClick={handleClickAllUnmaskButton}
                >
                  画像を鮮明にする
                </Button>
              </Grid>
              <Grid item>
                <Typography align="center" className="text-sm" color="primary">
                  取得には2~3分ほどかかります
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      {isLoading && <LongLoading />}
      <ErrorDialog
        open={!!errorDialogMessage.length}
        title={'画像を鮮明にできませんでした'}
        buttonLabel="閉じる"
        buttonAction={() => {
          setErrorDialogMessage('');
        }}
      >
        {errorDialogMessage}
      </ErrorDialog>
    </Box>
  );
};
export default MedicalHealthInformationBranchMediaImage;
